import React from "react";
import { Tooltip } from "antd";
import { AiOutlineApartment } from "react-icons/ai";
import { useTranslation } from "react-i18next";

interface RecommendationJobIndicatorProps {
  configured: boolean;
  /** Icon size in px */
  size?: number;
}

const RecommendationJobIndicator: React.FC<RecommendationJobIndicatorProps> = ({
  configured,
  size = 14,
}) => {
  const { t } = useTranslation();
  const title = configured
    ? t("DataScienceJobs-SelectedForRecommendations")
    : t("DataScienceJobs-NotSelectedForRecommendations");
  const color = configured ? "#000" : "#bfbfbf";

  return (
    <Tooltip title={title}>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "default",
          lineHeight: 0,
        }}
      >
        <AiOutlineApartment size={size} color={color} aria-hidden />
      </span>
    </Tooltip>
  );
};

export default RecommendationJobIndicator;
